import React from "react";
import { QuizWrapper } from "~shared/components/QuizWrapper";
import { QuizChooseItem } from "~/modules/QuizChooseItem";

const Theme40Task2 = () => {
  const items: { name: string }[] = [
    {
      name: "Башня Шухова"
    },
    {
      name: "Эйфелева башня"
    },
    {
      name: "Останкинская башня"
    },
    { name: "Кремлёвские башни" }
  ];
  return (
    <QuizWrapper
      title='Тест'
      icon='test'
      subtitle='Какая башня самая высокая в Европе?'
      description='Выбери правильный ответ'
      successIcon='rus-1'
    >
      <QuizChooseItem type='str' items={items} correctItem='Останкинская башня' sameHeight />
    </QuizWrapper>
  );
};

export default Theme40Task2;
